export enum HeaderNavbarItemTypeEnum {
  link = 'link',
  dropdown = 'dropdown',
  megaMenu = 'megaMenu',
}
